module.exports = "<div class=\"footer\">\r\n  <div>\r\n    <strong>Copyright</strong> Electronicline ™ {{dt.getFullYear()}} | Powered by Electronicline ™\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/footer/footer.template.html
// module id = 1087
// module chunks = 0